import { Backdrop, Grow, Modal } from '@material-ui/core';
import $ from 'jquery';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import Switch from 'react-switch';
import Security from '../../commons/security/Security.js';
import * as Utils from '../../commons/utils/Utils';

const COLUMNAS_A_EXPORTAR = { identificador: true, tipo: true, marca: true, modelo: true, vehiculo: true };

const claveSeleccionExport = () => Security.claveDeUsuario('EquipamientoGridSeleccionExport');

const leerGuardado = () => {
	try {
		return JSON.parse(window.localStorage.getItem(claveSeleccionExport()));
	} catch (e) {
		return null;
	}
};

const guardar = (activo, columnas) => {
	window.localStorage.setItem(claveSeleccionExport(), JSON.stringify({ activo: activo, dataToExport: columnas }));
};

const seleccionInicial = () => {
	const guardado = leerGuardado();
	return guardado && guardado.activo && guardado.dataToExport
		? Object.assign({}, COLUMNAS_A_EXPORTAR, guardado.dataToExport)
		: Object.assign({}, COLUMNAS_A_EXPORTAR);
};

const EquipamientoGridExport = (props) => {
	const intl = useIntl();
	const [loading, setLoading] = useState(false);
	const [dataToExport, setDataToExport] = useState(seleccionInicial);
	const [persisteSeleccion, setPersisteSeleccion] = useState(() => Boolean((leerGuardado() || {}).activo));

	const etiquetas = {
		identificador: intl.formatMessage({ id: 'equipamientoGrid.columns_label.identificador', defaultMessage: 'Identificador' }),
		tipo: intl.formatMessage({ id: 'equipamientoGrid.columns_label.tipo', defaultMessage: 'Tipo' }),
		marca: intl.formatMessage({ id: 'equipamientoGrid.columns_label.marca', defaultMessage: 'Marca' }),
		modelo: intl.formatMessage({ id: 'equipamientoGrid.columns_label.modelo', defaultMessage: 'Modelo' }),
		vehiculo: intl.formatMessage({ id: 'equipamientoGrid.columns_label.movil', defaultMessage: 'Móvil' }),
	};

	const actualizar = (columnas) => {
		if (persisteSeleccion) guardar(true, columnas);
		setDataToExport(columnas);
	};

	const todasTildadas = Object.keys(dataToExport).every((columna) => dataToExport[columna]);

	const handleToggleAll = () => {
		const nuevas = {};
		Object.keys(dataToExport).forEach((columna) => { nuevas[columna] = !todasTildadas; });
		actualizar(nuevas);
	};

	const handlePersisteSeleccion = (valor) => {
		guardar(valor, dataToExport);
		setPersisteSeleccion(valor);
	};

	const handleExportExcel = (event) => {
		event.preventDefault();
		setLoading(true);
		Utils.sendDataBlob('/equipamiento/exportar-excel' + props.queryFilters(), 'POST', JSON.stringify({ colsAExportar: dataToExport }))
			.then((data) => {
				const fileUrl = URL.createObjectURL(new File([data], 'fleet-equipamientos.xlsx'));
				$('<a />', { href: fileUrl, download: 'fleet-equipamientos.xlsx' }).appendTo('body').get(0).click();
			})
			.catch(() => {})
			.finally(() => {
				props.handleClose();
				setLoading(false);
			});
	};

	return (
		<Modal open={props.open} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 1000 }}>
			<Grow in={props.open}>
				<div tabIndex="-1" id="export_modal" role="dialog" aria-labelledby="exportEquipamientoTitulo">
					<div className="modal-xl modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white" id="exportEquipamientoTitulo">
									<i className="ft-download align-middle icon-modal-title"></i>
									<FormattedMessage id="equipamientoGrid.export_modal.titulo" defaultMessage=" Exportar Equipamientos" />
								</h4>
								<button type="button" onClick={() => props.handleClose()} className="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								<form className="form form-horizontal">
									<div className="form-body">
										<div className="card pull-up">
											<div className="card-content">
												<div className="card-body">
													<h4 className="form-section">
														<i className="la la-columns"></i>
														<FormattedMessage id="equipamientoGrid.export_modal.columnas_a_exportar" defaultMessage=" Columnas a exportar" />
													</h4>
													<div className="row">
														{Object.keys(COLUMNAS_A_EXPORTAR).map((columna) => (
															<div className="col-md-3" style={{ display: 'flex', alignItems: 'center', padding: '4px 0px' }} key={columna}>
																<label className="col-md-6 label-control col-form-label" htmlFor={columna}>{etiquetas[columna]}:</label>
																<Switch
																	onChange={() => actualizar(Object.assign({}, dataToExport, { [columna]: !dataToExport[columna] }))}
																	checked={Boolean(dataToExport[columna])}
																	id={columna}
																	offColor="#FF4961"
																	onColor="#28D094"
																	className="col-md-6 align-middle"
																/>
															</div>
														))}
													</div>
													<hr />
													<div className="row" style={{ marginBottom: '8px' }}>
														<div className="col-md-3">
															<label className="col-md-6 label-control col-form-label" htmlFor="persisteSeleccionExport">
																<FormattedMessage id="equipamientoGrid.export_modal.mantener_seleccion" defaultMessage="Mantener Selección:" />
															</label>
															<Switch id="persisteSeleccionExport" onChange={handlePersisteSeleccion} checked={persisteSeleccion} offColor="#FF4961" onColor="#28D094" className="col-md-6 align-middle" />
														</div>
													</div>
													<div className="row">
														<div className="col-md-3">
															<label className="col-md-6 label-control col-form-label" htmlFor="marcarDesmarcarTodo">
																<FormattedMessage id="equipamientoGrid.export_modal.marcar_desmarcar_todo" defaultMessage="Marcar / Desmarcar todo:" />
															</label>
															<Switch id="marcarDesmarcarTodo" onChange={handleToggleAll} checked={todasTildadas} offColor="#FF4961" onColor="#28D094" className="col-md-6 align-middle" />
														</div>
													</div>
												</div>
											</div>
										</div>
										<div className="col-md-12 alert alert-info small" role="alert">
											<FormattedMessage id="equipamientoGrid.export_modal.puede_demorar" defaultMessage="Esta acción puede demorar unos minutos." />
										</div>
									</div>
								</form>
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-default btn-fleet" onClick={handleExportExcel}>
									<i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i>
									<FormattedMessage id="equipamientoGrid.export_modal.exportar_a_excel" defaultMessage=" Exportar a Excel" />
								</button>
								<button type="button" className="btn btn-danger" onClick={() => props.handleClose()}>
									<i className="fa fa-times-circle"></i>
									<FormattedMessage id="equipamientoGrid.export_modal.cancelar" defaultMessage=" Cancelar" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default EquipamientoGridExport;
